import React, { Component } from 'react';
import 'styled-components/macro';
import * as types from 'styled-components/cssprop'; /* eslint-disable-line */
import { css, withTheme } from 'styled-components';
import { isMobile } from '@/utils/constants';
import { Context } from '../../i18n';

class CloseButton extends Component<{
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  theme: any;
  isRTL: boolean;
  hideCloseBtn?: boolean;
  isVoice?: boolean;
}> {
  static contextType = Context;
  context!: React.ContextType<typeof Context>;
  handlerEnterDown = (e: any) => {
    if (e.keyCode === 13) {
      this.props.onClick(e);
    }
  };
  render() {
    const { voice_text } = this.context;

    const { closeIconColor } = this.props.theme;
    const { isRTL, isVoice } = this.props;

    return (
      <div
        className="captcha_verify_bar--close"
        css={css`
          ${isRTL ? 'left: 0;' : 'right: 0;'}
          top: 0;
          position: absolute;
          z-index: 2;
        `}
      >
        {!this.props.hideCloseBtn && (
          <a
            className="verify-bar-close"
            css={css`
              cursor: pointer;
              padding: ${isVoice ? (isMobile ? '0.14em' : '0.20em') : '0.08em'};
              display: block;
              width: ${isVoice ? (isMobile ? '0.12em' : '0.16em') : '0.2em'};
              height: ${isVoice ? (isMobile ? '0.12em' : '0.16em') : '0.2em'};
              box-sizing: content-box;
              svg {
                /* height: 100%; */
                width: 100%;
                display: block;
              }
            `}
            id="verify-bar-close"
            onClick={this.props.onClick}
            role="button"
            aria-label={voice_text?.aria_label_close_btn}
            tabIndex={1}
            onKeyDown={(e) => {
              return this.handlerEnterDown(e);
            }}
          >
            {isVoice ? (
              isMobile ? (
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.150631 0.877941C-0.0502103 0.6771 -0.0502103 0.351472 0.150631 0.150631C0.351472 -0.0502103 0.6771 -0.0502103 0.877941 0.150631L11.8494 11.1221C12.0502 11.3229 12.0502 11.6485 11.8494 11.8494C11.6485 12.0502 11.3229 12.0502 11.1221 11.8494L0.150631 0.877941Z"
                    fill="#999999"
                  />
                  <path
                    d="M0.877941 11.8494C0.6771 12.0502 0.351472 12.0502 0.150631 11.8494C-0.0502103 11.6485 -0.0502103 11.3229 0.150631 11.1221L11.1221 0.150631C11.3229 -0.0502103 11.6485 -0.0502103 11.8494 0.150631C12.0502 0.351472 12.0502 0.6771 11.8494 0.877941L0.877941 11.8494Z"
                    fill="#999999"
                  />
                </svg>
              ) : (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.44 2.50738C12.5702 2.3772 12.7812 2.3772 12.9114 2.50738L13.3828 2.97878C13.513 3.10895 13.513 3.32001 13.3828 3.45018L8.90446 7.92853L13.3828 12.4069C13.513 12.537 13.513 12.7481 13.3828 12.8783L12.9114 13.3497C12.7812 13.4799 12.5702 13.4799 12.44 13.3497L7.96165 8.87134L3.48331 13.3497C3.35314 13.4799 3.14208 13.4799 3.01191 13.3497L2.5405 12.8783C2.41033 12.7481 2.41033 12.537 2.5405 12.4069L7.01885 7.92853L2.5405 3.45018C2.41033 3.32001 2.41033 3.10895 2.5405 2.97878L3.01191 2.50738C3.14208 2.3772 3.35314 2.3772 3.48331 2.50738L7.96165 6.98572L12.44 2.50738Z"
                    fill="#999999"
                  />
                </svg>
              )
            ) : (
              <svg
                className="verify-bar-close--icon"
                width="20px"
                height="20px"
                viewBox="0 0 20 20"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g
                  transform="translate(3.875000, 3.875000)"
                  fill={closeIconColor}
                  fillRule="nonzero"
                >
                  <path
                    d="M11.6087836,0.641216373 C11.7970721,0.829504871 11.7970721,1.13478084 11.6087836,1.32306934 L6.807,6.125 L11.6087836,10.9269307 C11.7970721,11.1152192 11.7970721,11.4204951 11.6087836,11.6087836 C11.4204951,11.7970721 11.1152192,11.7970721 10.9269307,11.6087836 L6.125,6.807 L1.32306934,11.6087836 C1.13478084,11.7970721 0.829504871,11.7970721 0.641216373,11.6087836 C0.452927876,11.4204951 0.452927876,11.1152192 0.641216373,10.9269307 L5.443,6.125 L0.641216373,1.32306934 C0.452927876,1.13478084 0.452927876,0.829504871 0.641216373,0.641216373 C0.829504871,0.452927876 1.13478084,0.452927876 1.32306934,0.641216373 L6.125,5.443 L10.9269307,0.641216373 C11.1152192,0.452927876 11.4204951,0.452927876 11.6087836,0.641216373 Z"
                    id="Path"
                  />
                </g>
              </svg>
            )}
          </a>
        )}
      </div>
    );
  }
}

export default withTheme(CloseButton);
